<template>
  <div
    id="categoryTable"
    v-loading="categoryLoading"
    :style="{
      overflow: categoryLoading ? 'hidden !important' : null,
    }"
  >
    <!-- tableContainer 'blocked' mean 'overlap coming soon' area -->
    <div
      class="tableContainer blocked"
      :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
    >
      <div class="tableMain header">
        <div class="tableRow first rowHeader">
          {{ $t('coach.category.title') }}
        </div>
        <div class="tableRow rowHeader">
          12 {{ $t('coach.category.monthShort') }}
          <el-tooltip
            effect="dark"
            placement="top"
            :content="'No Growth no pay'"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <div class="tableRow rowHeader">
          12 {{ $t('coach.category.monthShort') }}
        </div>
        <div class="tableRow rowHeader">
          9 {{ $t('coach.category.monthShort') }}
        </div>
        <div class="tableRow rowHeader">
          6 {{ $t('coach.category.monthShort') }}
        </div>
        <div class="tableRow rowHeader">
          3 {{ $t('coach.category.monthShort') }}
        </div>
        <!--<div class="tableRow">
          Hourly
        </div>-->
      </div>
      <div
        v-for="(row, rowIndex) in categories"
        :key="`tableRow${rowIndex}`"
        class="tableMain row"
      >
        <div class="tableRow first">
          <div class="badgeWrap">
            <div
              class="optionBadge"
              :class="rowIndex < 6 ? 'onlineOnly' : 'hybrid'"
            >
              <span v-if="rowIndex < 6">{{ $t('coachingTier.onlineOnly') }}</span>
              <span v-else>{{ $t('coachingTier.hybrid') }}</span>
            </div>
          </div>
          <div class="firstWrap">
            <div class="number">
              {{ rowIndex + 1 }}.
            </div>
            <div>
              <span class="title">
                {{ $t(`coachingTier.${row.category.key}`) }}
              </span>
              <span class="caption">
                {{ $t(`coachingTier.${row.category.key}_caption`) }}
              </span>
            </div>
          </div>
        </div>
        <!-- tableRow : If flexGrow set as null, the width will not matched within 1px.. -->
        <div
          v-for="(option, cellIndex) in row.options"
          :key="`cell${cellIndex}`"
          class="tableRow"
          :style="{
            flexGrow: option.span ? option.span : 0,
            margin: option.span ? 'auto -0.2px' : null,
            textTransform: 'capitalize',
          }"
        >
          {{ option.item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryTable',

  props: {
    categoryLoading: {
      type: Boolean,
      default: false,
    },

    categories: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>

<style lang="scss" scoped>
  // Global table area css
  #categoryTable {
    width: 100%;
    scrollbar-color: #c8c8c8 transparent;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c8c8c8;
      border-radius: 20px;
    }

    &::-webkit-scrollbar-track {
      background: transparent !important;
    }

    .el-tooltip {
      z-index: 10;
      padding: 0;
      font-size: 0.9em;
    }
  }
</style>

<style lang="scss" scoped>
  // Table css
  #categoryTable {
    $table-header: rgba(255, 255, 255, 0.1);
    $table-border: var(--themeFontColor);

    .tableContainer {
      div {
        box-sizing: border-box;
      }

      display: block;
      position: relative;
      margin: 2em auto;
      width: 100%;
      min-width: 700px;
      overflow: hidden;

      &.blocked {
        .el-tooltip {
          opacity: 0.7;
        }

        /* &::before {
          content: 'Coming soon';
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          font-style: italic;
          top: 1px;
          right: 1px;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          width: calc(((100% - 280px) / 6) * 3 + 3.5px);
          height: calc(100% - 2px);
          background: rgba(0, 0, 0, 0.5);
        } */

        /* &::after {
          content: 'Coming soon';
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          font-style: italic;
          top: 1px;
          left: 271px;
          width: calc(((100% - 280px) / 6) * 2 + 2px);
          height: calc(100% - 2px);
          background: rgba(0, 0, 0, 0.5);
        } */
      }

      // Mobile mode disable for coming soon area

      /* &.mobileMode {
        .tableMain {
          // Mobile First row cells
          &:first-of-type .tableRow {
            &:first-child { border-top-right-radius: 8px; }
            &:last-child { border-top-right-radius: 0 !important; }
          }

          // Mobile Last row cells
          &:last-of-type .tableRow {
            &:first-child { border-bottom-left-radius: 0 !important; }
            &:nth-child(2) { border-bottom-left-radius: 8px; }
            &:last-child { border-bottom-right-radius: 8px; }
          }

          .tableRow {
            width: calc(100% / 6);
            &.first {
              justify-content: center;
              width: 100%;
            }
          }

          .tableColumn {
            width: 100%;
          }
        }
      } */
    }

    .tableMain {
      display: flex;
      flex-flow: row wrap;
      border-left: solid 1px $table-border;
      transition: 0.5s;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transition: 500ms;
      }

      // First row
      &:first-of-type {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        border-top: solid 1px $table-border;
        border-left: solid 1px $table-border;
        font-weight: bold;
      }
      // First row cells
      &:first-of-type .tableRow {
        background: $table-header;
        color: var(--themeFontColor);
        border-color: $table-border;
        &:last-child { border-top-right-radius: 8px; }
      }

      // Last row
      &:last-of-type {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      // Last row cells
      &:last-of-type .tableRow {
        &:first-child { border-bottom-left-radius: 8px; }
        &:last-child { border-bottom-right-radius: 8px; }
      }
    }

    .tableRow {
      width: calc((100% - 290px) / 5);

      &.rowHeader {
        min-height: 50px;
      }

      &:not(.rowHeader) {
        min-height: 75px;
      }

      text-align: center;
      padding: 0.8em 0.8em;
      border-right: solid 1px $table-border;
      border-bottom: solid 1px $table-border;

      &.first {
        min-width: 290px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        padding-left: 14px;

        .badgeWrap {
          width: 100%;
          display: flex;

          .optionBadge {
            padding: 3px 12px;
            margin-bottom: 2px;
            border-radius: 4px;
            font-size: 12px;
            line-height: 12px;

            &.onlineOnly {
              background: #02be90;
            }

            &.hybrid {
              background: #f09e00;
            }
          }
        }

        .firstWrap {
          display: flex;

          .number {
            padding-right: 4px;
          }

          .title {
            font-weight: bold;
          }

          .caption {
            font-size: 13px;
            font-style: italic;
            font-weight: lighter;
          }
        }
      }

      &:not(.first) {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &.colSpan {
        display: flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: center;
      }
    }

    .rowspan {
      display: flex;
      flex-flow: row wrap;
      align-items: flex-start;
      justify-content: center;
    }

    .tableColumn {
      display: flex;
      flex-flow: column wrap;
      width: 75%;
      padding: 0;

      .tableRow {
        display: flex;
        flex-flow: row wrap;
        width: 100%;
        padding: 0;
        border: 0;
        border-bottom: solid 1px $table-border;
      }
    }
  }
</style>
